import validate from 'validate.js';

const constraints = {
    title: {
	presence: { 
	    message: 'napiši naslov'
	}
    },
    stream_id: {
	presence: { 
	    message: 'vstavi id straminga'
	}
    },
    date_from: {
	presence: { 
	    message: 'zberi datum'
	}
    },
    date_to: {
	presence: { 
	    message: 'zberi datum'
	}
    }
}

export default( fields ) => {
    return validate(fields, constraints, {fullMessages: false}) || {};
}




// WEBPACK FOOTER //
// ./src/validators/StreamingValidator.js